module.exports = __webpack_public_path__ + "img/08_DSC7755-mobileVersion-min.e7010a30.jpg";